module.exports = __webpack_public_path__ + "assets/img/WechatIMG66.ac7c4339.png";